var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 25",
    width: "32px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9856C",
    d: "m13.8723 0 2.78172414 1.12339255-1.87232092 4.6362069-2.78172414-1.12339255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9654E9",
    d: "m20.4254 24.2162-1.56733464.52561281-1.10636773-2.72275202 1.56733464-.52561281z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6CF9D8",
    strokeWidth: 1.2,
    d: "M8.0821 25s-.48679-2.8918.91025-3.4682c1.17365-.4842 2.19115 1.6572 3.15555.8809.9768-.7864-1.4617-2.0322-.6675-2.9728.8358-.9898 3.5196 0 3.5196 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6CF9D8",
    d: "m19.6732 11.3156.498-4.29527 3.4717 2.20088.3957-3.60325 3.1666 2.1814.9863-3.89541"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 11 .6735 2.0729h2.1797l-1.7634 1.2812.6736 2.073L15 15.1459l-1.7634 1.2812.6736-2.073-1.7634-1.2812h2.1797L15 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9654E9",
    strokeWidth: 1.2,
    d: "M-.00000376 13.5575S6.39427 10.3727 7.84483 12.042c.79691.9171 1.39872 2.0278.68501 2.9302-.55017.6957-1.34448.7844-2.27517.6209-1.97086-.3461-1.94097-3.083-1.14982-4.778 1.09231-2.34036 6.89075-.959 6.89075-.959"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F9856C",
    strokeWidth: 1.2,
    d: "M32.1461 20.0938s-7.1396-.2369-7.6225-2.395c-.2653-1.1857-.2669-2.449.79-2.9037.8147-.3506 1.5557-.0511 2.2968.535 1.5696 1.2412.2425 3.6351-1.2592 4.7504-2.0733 1.54-6.5185-2.4312-6.5185-2.4312"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v25H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.4b3f445b.svg";
export { ForwardRef as ReactComponent };